'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M209.7 302.3c-15.3-15.3-34.9-25.3-55.9-28.9c31-125.8 90-191.8 150.9-225.1C367.6 14 435 13.2 481.2 21.1c5 .9 8.8 4.7 9.7 9.7c8 46.1 7.2 113.5-27.2 176.5c-33.3 60.9-99.3 119.9-225.1 150.9c-3.6-21-13.6-40.6-28.9-55.9zM240 375.6l0-1.2c51.4-12.5 93.6-29.6 128-49.8l0 85.7c0 15.2-8.6 29-22.1 35.8l-94.3 47.2c-5.3 2.7-11.6-1.2-11.6-7.2l0-110.5zm144 34.7l0-95.7C510.9 230.8 519.5 102.5 506.6 28.1c-2-11.6-11.1-20.7-22.7-22.7C409.5-7.5 281.3 1.1 197.4 128l-95.7 0c-21.2 0-40.6 12-50.1 31L4.4 253.3c-8 16 3.6 34.7 21.5 34.7l110.5 0c23.2 0 45.5 9.2 61.9 25.7s25.7 38.7 25.7 61.9l0 110.5c0 17.8 18.8 29.4 34.7 21.5L353 460.4c19-9.5 31-28.9 31-50.1zM137.7 272l-1.2 0L25.9 272c-5.9 0-9.8-6.3-7.2-11.6l47.2-94.3c6.8-13.6 20.6-22.1 35.8-22.1l85.7 0c-20.2 34.4-37.3 76.6-49.8 128zm17.5 186.7c-14.1 14.1-35.8 23.4-60.2 29.2c-24.1 5.7-48.8 7.6-67 8c-6.8 .2-12-5-11.8-11.8c.4-18.2 2.3-43 8-67c5.8-24.4 15.1-46.1 29.2-60.2c28.1-28.1 73.8-28.1 101.9 0s28.1 73.8 0 101.9zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM408 144a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;